import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import ListEmptyState from '@components/v2/ui/EmptyState/ListEmptyState';
import CatalogsIllustration from '@components/v2/ui/EmptyState/svg/CatalogsIllustration';
import { useHistory } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import PATHS from '../../../../../routes/routes.const';

interface CatalogProductsEmptyStateProps {
  hasActiveFilters: boolean;
}

const CatalogProductsEmptyState = ({ hasActiveFilters }: CatalogProductsEmptyStateProps) => {
  const history = useHistory();

  return (
    <ListEmptyState hasActiveFilters={hasActiveFilters}>
      <EmptyState
        title={{ text: LangEnum.GLOBAL_CATALOG }}
        description={{ text: LangEnum.CATALOG_PRODUCTS_V2_EMPTY_DESCRIPTION }}
        illustration={<CatalogsIllustration />}
        action={{
          primary: {
            label: LangEnum.CATALOG_PRODUCTS_V2_GO_TO_ALL_PRODUCTS,
            onClick: () => history.push(PATHS.main.products.path),
          },
        }}
      />
    </ListEmptyState>
  );
};

export default CatalogProductsEmptyState;
